import { defineQueryKeys } from '@/shared/lib/queryKeys';

/** 목록 필터. `'ALL'` 은 상태 무관을 뜻하는 화면 기본값이다. */
export type PayoutStatusFilter = 'ALL' | 'PENDING' | 'PAID' | 'VOIDED';

/**
 * 정산 목록·요약·회차 쿼리 키.
 *
 * 대표 콘솔의 원장 마감도 정산 화면을 무효화해야 하므로 shared 에 둔다. 정산 feature 와
 * 대표 콘솔이 같은 루트를 써서 마감 직후 현재 회차가 곧바로 다시 조회된다.
 */
export const payoutKeys = defineQueryKeys('payouts', (all) => ({
  list: (status: PayoutStatusFilter, includeVoided: boolean, period = 'ALL', userId = 'ALL') =>
    [...all, 'list', status, includeVoided, period, userId] as const,
  summary: (period = 'ALL', userId = 'ALL') => [...all, 'summary', period, userId] as const,
  lastClosedPeriod: () => [...all, 'last-closed-period'] as const,
  byPeriod: (userId: string) => [...all, 'by-period', userId] as const,
}));
